define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const util = require('utils');
    const dateUtil = require('util/date.util');
    const BaseView = require('common/base.view');
    const BirthRegionModel = require('common/birthRegion.model');

    const ITALY_COUNTRY_CODE = 'IT';

    module.exports = BaseView.extend({
        options: {
            countryCondition: ITALY_COUNTRY_CODE,
            template: 'placeOfBirthTmpl'
        },

        events: {
            'change [name="day_dateOfBirthInner"]': 'handleDateOfBirthChange',
            'change [name="month_dateOfBirthInner"]': 'handleDateOfBirthChange',
            'change [name="year_dateOfBirthInner"]': 'handleDateOfBirthChange',
            'change [name="countryOfBirth"]': 'handleCountryOfBirthChange',
            'change [name="birthProvince"]': 'handleBirthProvinceChange'
        },

        initialize: function(options) {
            this.options = { ...this.options, ...options };
            this.options.innerFields = Object.values(options.innerFields || {})
                .filter(field => field.active)
                .sort((field1, field2) => field1.order - field2.order)
                .map(field => {

                    if (field.type === 'dateOfBirthInner') {
                        const defaultMax = 'today';
                        const defaultMin = '-100y';
                        const dateRangeRule = field.validationRules.find(item => item.type === 'dateRange');
                        const max = field.validation && dateRangeRule?.max || defaultMax;
                        const min = field.validation && dateRangeRule?.min || defaultMin;
                        const maxYear = new Date(dateUtil.parseStringDateToUnixFormat(max))?.getFullYear() || new Date(dateUtil.parseStringDateToUnixFormat(defaultMax))?.getFullYear();
                        const minYear = new Date(dateUtil.parseStringDateToUnixFormat(min))?.getFullYear() || new Date(dateUtil.parseStringDateToUnixFormat(defaultMin))?.getFullYear();

                        field.yearsRange = {
                            [field.name]: _.range(maxYear, minYear - 1)
                        };
                    }

                    field.isLabelAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isLabelAsteriskEnabled);
                    field.isPlaceholderAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isPlaceholderAsteriskEnabled);

                    return field;
                });

            this.model = new BirthRegionModel();
        },

        subscribe: function() {
            this.listenTo(this.model, 'change:birthCountries', this.updateCountriesList);
            this.listenTo(this.model, 'change:regionsByCountryCode', this.updateProvincesList);
        },

        render: function() {
            if (!this.options.innerFields.length) {
                return this;
            }

            this.$el.html(this.tmpl(this.options.template, this.options));
            this.$el.removeClass('fn-validate');
        },

        handleDateOfBirthChange: function() {
            const dd = this.$el.find('[name="day_dateOfBirthInner"]').val();
            const mm = this.$el.find('[name="month_dateOfBirthInner"]').val();
            const yyyy = this.$el.find('[name="year_dateOfBirthInner"]').val();

            if (!dd || !mm || !yyyy) {
                return;
            }

            this.disableField('dateOfBirthInner');
            this.toggleFieldVisibility('countryOfBirth', false);
            this.toggleFieldVisibility('birthProvince', false);
            this.toggleFieldVisibility('cityOfBirth', false);

            this.model.fetchCountries(`${yyyy}-${mm}-${dd}`)
                .done((birthCountries) => {
                    this.model.set({ birthCountries });
                    this.model.trigger('change:birthCountries');
                })
                .fail((errorMsg) => {
                    this.options.form.showErrorMessage(errorMsg);
                })
                .always(() => {
                    this.enableField('dateOfBirthInner');
                });
        },

        handleCountryOfBirthChange: function(event) {
            this.toggleFieldVisibility('birthProvince', false);
            this.toggleFieldVisibility('cityOfBirth', false);

            const dd = this.$el.find('[name="day_dateOfBirthInner"]').val();
            const mm = this.$el.find('[name="month_dateOfBirthInner"]').val();
            const yyyy = this.$el.find('[name="year_dateOfBirthInner"]').val();

            // countryOfBirth option value example: "Z114-GB"
            const countryCode = (event.target.value || '').split('-')[1];

            if (countryCode !== this.options.countryCondition) {
                return;
            }

            this.disableField('dateOfBirthInner');
            this.disableField('countryOfBirth');

            this.model.fetchRegionsByCountryCode(`${yyyy}-${mm}-${dd}`, countryCode)
                .done((regionsByCountryCode) => {
                    this.model.set({ regionsByCountryCode });
                    this.model.trigger('change:regionsByCountryCode');
                })
                .fail((errorMsg) => {
                    this.options.form.showErrorMessage(errorMsg);
                })
                .always(() => {
                    this.enableField('dateOfBirthInner');
                    this.enableField('countryOfBirth');
                });
        },

        handleBirthProvinceChange: function() {
            this.updateCitiesList();
        },

        updateCountriesList: function() {
            const birthCountries = this.model.get('birthCountries');
            // regulationCode is used to validate italianID field
            // code is used to fetch regions and is sent in CreatePlayerInfoDataMap
            const options = birthCountries?.map(country => ({
                value: `${country.regulationCode}-${country.code}`,
                label: country.name
            }));

            this.updateSelectWithOptions('countryOfBirth', options);
            this.toggleFieldVisibility('countryOfBirth', options.length > 0);
        },

        updateProvincesList: function() {
            const provinces = this.model.getProvinces();
            const options = provinces?.map(province => ({
                value: province.abbreviation,
                label: province.name
            }));

            this.updateSelectWithOptions('birthProvince', options);
            this.toggleFieldVisibility('birthProvince', options.length > 0);
        },

        updateCitiesList: function() {
            const selectedProvinceCode = this.$el.find('#birthProvince').val();
            const cities = this.model.getProvinceCities(selectedProvinceCode);
            // officialCode is used to validate italianID field
            // name is sent in CreatePlayerInfoDataMap
            const options = cities?.map(city => ({
                value: `${city.officialCode}-${city.name}`,
                label: city.name
            }));

            this.updateSelectWithOptions('cityOfBirth', options);
            this.toggleFieldVisibility('cityOfBirth', options.length > 0);
        },

        disableField: function(name) {
            if (name === 'dateOfBirthInner') {
                this.disableField('day_dateOfBirthInner');
                this.disableField('month_dateOfBirthInner');
                this.disableField('year_dateOfBirthInner');

                return;
            }

            const $el = this.$el.find(`#${name}:not(.inner-field-disabled)`);

            $el.attr('disabled', 'disabled').addClass('inner-field-disabled');
        },

        enableField: function(name) {
            if (name === 'dateOfBirthInner') {
                this.enableField('day_dateOfBirthInner');
                this.enableField('month_dateOfBirthInner');
                this.enableField('year_dateOfBirthInner');

                return;
            }

            const $el = this.$el.find(`#${name}.inner-field-disabled`);

            $el.removeAttr('disabled').removeClass('inner-field-disabled');
        },

        toggleFieldVisibility: function(name, isVisible) {
            const $field = this.$el.find(`.field_name_${name}`);

            if (isVisible) {
                this.enableField(name);
            } else {
                this.disableField(name);
            }

            $field.toggleClass('hidden', !isVisible);
        },

        updateSelectWithOptions: function(name, options = []) {
            const $el = this.$el.find(`#${name}`);

            $el.val('');
            $el.find('option:not([value=""])').remove();
            this.options.form.refreshSelectField($el);

            if (options.length > 0) {
                $el.append(options
                    .map(option => ({
                        value: util.replaceHtmlEntities(option.value),
                        label: util.replaceHtmlEntities(option.label)
                    }))
                    .sort((op1, op2) => {
                          if (op1.label < op2.label) {
                              return -1;
                          }
                          if (op1.label > op2.label) {
                              return 1;
                          }
                          return 0;
                    })
                    .reduce((accHtml, { value, label }) => accHtml + `<option value="${value}">${label}</option>`, '')
                );
            }
        }
    });
});
